import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const MilestoneService = {
  getList: async () => {
    const response = await apiService.get("/organizationtimeline");
    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/organizationtimeline/${id}`);
    return response.data;
  },
  getbySlug: async (id) => {
    const response = await apiService.get(
      `/organizationtimeline/slug?slug=${id}`
    );
    return response.data;
  },
};

export default MilestoneService;
